<div class="unauth-wrap">
  <div class="unauth-card">
    <div class="unauth-icon">
      <svg width="64" height="64" viewBox="0 0 64 64" fill="none">
        <circle cx="32" cy="32" r="32" fill="#fff3f3"/>
        <path d="M32 18a10 10 0 0 0-10 10v4h-2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V34a2 2 0 0 0-2-2h-2v-4a10 10 0 0 0-10-10zm0 4a6 6 0 0 1 6 6v4H26v-4a6 6 0 0 1 6-6zm0 14a2 2 0 1 1 0 4 2 2 0 0 1 0-4z" fill="#A5300F"/>
      </svg>
    </div>
    <h1 class="unauth-code">403</h1>
    <h2 class="unauth-title">Access Restricted</h2>
    <p class="unauth-msg">You don't have permission to view this page. Please contact your administrator if you believe this is a mistake.</p>
    <button class="unauth-btn" (click)="goBack()">Go to Dashboard</button>
  </div>
</div>
